import { render, staticRenderFns } from "./LoyaltyNotSubscirbe.vue?vue&type=template&id=371dab58&"
import script from "./LoyaltyNotSubscirbe.vue?vue&type=script&lang=js&"
export * from "./LoyaltyNotSubscirbe.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyNotSubscirbe.vue?vue&type=style&index=0&id=371dab58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardLoyaltyBox: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/CardLoyaltyBox.vue').default})
